import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import { Container } from '../../../../ui/gridSystem';
import { CTA, CustomSelect, Icon, Text } from '../../../../ui/atoms';
import {
  InfoBox,
  Card,
  CardsGrid,
  TitleWrapper,
  InfoBoxMobile,
  LargeChartGrid,
  ChartsWrapper,
  ChartLegend,
  ColorBox,
  FullDataBox,
  Column,
  CardInner,
  RefreshAndLegend,
  EmptyElement,
  TextAndFilter,
  LegendItem,
  DataBit,
  DataAndLegend,
  TutorChartWrapper,
  CourseFiltersWrapper,
  ModalsWrapper,
} from './style';
import CircularStats from '../../../../ui/atoms/CircularStats';
import { MODAL_OPEN } from '../../../redux/actions';
import { withMediaQueries } from '../../../hoc/withMediaQueries';
import BarChart from '../../../../ui/components/BarChart';
import {
  barChartConfig,
  barChartConfigMultiSets,
  barChartConfigWithTrend,
  regionsProvinceLabels,
} from '../../../../utils/course-state';
import { ModalDownloadReportId } from '../../../../ui/atoms/Modals/ModalDownloadReport';
import ModalSupervisorCourses, {
  ModalSupervisorCoursesId,
} from '../../../../ui/atoms/Modals/Supervisor/ModalSupervisorCourses';
import { MY_USERS_GET } from '../../../redux/actions/statistics';
import theme from '../../../../ui/theme';
import TimeIntervalFilter from '../../../../ui/atoms/TimeIntervalFilter';
import { generateColorPalette } from '../../../../utils/colors';
import ModalSupervisorTutors, {
  ModalSupervisorTutorsId,
} from '../../../../ui/atoms/Modals/Supervisor/ModalSupervisorTutors';
import ModalSupervisorActivities, {
  ModalSupervisorActivitiesId,
} from '../../../../ui/atoms/Modals/Supervisor/ModalSupervisorActivities';
import ModalSupervisorUsers, {
  ModalSupervisorUsersId,
} from '../../../../ui/atoms/Modals/Supervisor/ModalSupervisorUsers';
import ModalSupervisorCategories, {
  ModalSupervisorCategoriesId,
} from '../../../../ui/atoms/Modals/Supervisor/ModalSupervisorCategories';
import {
  ACCESS_STATISTICS_LIST_GET,
  ACTIVITY_STATISTICS_LIST_GET,
  CATEGORY_STATISTICS_LIST_GET,
  COURSE_STATISTICS_LIST_GET,
  TUTOR_STATISTICS_LIST_GET,
} from '../../../redux/actions/supervisorStats';
import { COURSE_STATS_OPTS, formatFilterOpt } from '../../../../utils/labels';
import {
  ACCESS_STATS_CHART_OPTS,
  COURSE_STATS_CHART_OPTS,
  ACTIVITY_STATS_CHART_OPTS,
  REGION_PROVINCE_CHART_OPTS,
  arrayToKeyValue,
  formatAccessStats,
  formatNumberToK,
} from '../../../../utils/charts';
import RefreshBtn from '../../../../ui/atoms/RefreshBtn';
import { getCurrentMonthDate } from '../../../../utils/stats-date';

const customParseFormat = require('dayjs/plugin/customParseFormat');

dayjs.extend(customParseFormat);

const Statistics = ({
  mediaIsPhone,
  mediaIsTablet,
  modalOpen,
  myUsers,
  getMyUsers,
  getAccessStatisticsList,
  getActivityStatisticsList,
  getCategoryStatisticsList,
  getCourseStatisticsList,
  getTutorStatisticsList,
  accesses,
  activities,
  categories,
  courses,
  tutors,
  isOpen,
  modalId,
}) => {
  const [reducedStats, setReducedStats] = useState();
  const [filterIsProvince, setFilterIsProvince] = useState(false);
  const currentMonth = getCurrentMonthDate();

  useEffect(() => {
    if (mediaIsPhone || mediaIsTablet) setReducedStats(true);
    else setReducedStats(false);
  }, [mediaIsPhone, mediaIsTablet]);

  useEffect(() => {
    getTutorStatisticsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [myUsersFilters, setMyUsersFilters] = useState({
    filter: 'ffoo',
    start_date: currentMonth.start_date,
    end_date: currentMonth.end_date,
  });
  useEffect(() => {
    if (myUsersFilters?.filter !== 'province') {
      getMyUsers({ ...(delete myUsersFilters.region && myUsersFilters) });
    } else if (
      myUsersFilters?.filter === 'province' &&
      myUsersFilters?.region
    ) {
      getMyUsers(myUsersFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myUsersFilters]);

  useEffect(() => {
    if (reducedStats) {
      setMyUsersFilters({ ...myUsersFilters, filter: 'ffoo' });
      setFilterIsProvince(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reducedStats]);

  const [accessStatisticsFilters, setAccessStatisticsFilters] = useState({
    start_date: currentMonth.start_date,
    end_date: currentMonth.end_date,
  });
  useEffect(() => {
    getAccessStatisticsList(accessStatisticsFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessStatisticsFilters]);

  const [activityStatisticsFilters, setActivityStatisticsFilters] = useState({
    start_date: currentMonth.start_date,
    end_date: currentMonth.end_date,
  });
  useEffect(() => {
    getActivityStatisticsList(activityStatisticsFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityStatisticsFilters]);

  const [categoryStatisticsFilters, setCategoryStatisticsFilters] = useState({
    start_date: currentMonth.start_date,
    end_date: currentMonth.end_date,
  });
  useEffect(() => {
    getCategoryStatisticsList(categoryStatisticsFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryStatisticsFilters]);

  const [courseStatisticsFilters, setCourseStatisticsFilters] = useState({
    filter: 'nazionali_locali',
    start_date: currentMonth.start_date,
    end_date: currentMonth.end_date,
  });
  useEffect(() => {
    getCourseStatisticsList(courseStatisticsFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseStatisticsFilters]);

  const formatUsers = ({ items: users }) => {
    const formattedUsers = {};
    users?.forEach((u) => {
      formattedUsers[u?.label] = u?.count;
    });
    return formattedUsers;
  };

  const getDataLabels = (users) => {
    return (users?.assignments?.items || []).map(({ label }) => label);
  };

  const [regionProvinceStatistics, setRegionProvinceStatistics] = useState({
    start_date: currentMonth.start_date,
    end_date: currentMonth.end_date,
  });
  useEffect(() => {
    const formattedAssignments = Object.fromEntries(
      (myUsers?.assignments?.items ?? []).map((item) => [
        item.label,
        { assignments: item.count },
      ])
    );
    const formattedFruitions = Object.fromEntries(
      (myUsers?.fruitions?.items ?? []).map((item) => [
        item.label,
        { fruitions: item.count },
      ])
    );
    const formattedCompletions = Object.fromEntries(
      (myUsers?.completions?.items ?? []).map((item) => [
        item.label,
        { completions: item.count },
      ])
    );
    setRegionProvinceStatistics(
      deepMerge(
        {},
        formattedAssignments,
        formattedFruitions,
        formattedCompletions
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    myUsers?.assignments?.items,
    myUsers?.completions?.items,
    myUsers?.fruitions?.items,
  ]);

  function deepMerge(target, ...sources) {
    for (const source of sources) {
      for (const key in source) {
        if (source.hasOwnProperty(key)) {
          if (typeof source[key] === 'object' && !Array.isArray(source[key])) {
            if (!target[key]) {
              Object.assign(target, { [key]: {} });
            }
            deepMerge(target[key], source[key]);
          } else {
            Object.assign(target, { [key]: source[key] });
          }
        }
      }
    }
    return target;
  }

  return (
    <>
      <Container>
        <TitleWrapper>
          <Text type="h1">Statistiche</Text>
          {!reducedStats ? (
            <InfoBox className="d-flex sb">
              <Text type="b4">
                Vuoi consultare i report anche offline dal tuo computer?
                Effettua il download delle statistiche
              </Text>
              <CTA
                type="tertiary"
                btnText="Download statistiche supervisor"
                icon="download-01"
                onClick={() => modalOpen(ModalDownloadReportId)}
              />
            </InfoBox>
          ) : (
            <InfoBoxMobile>
              <Icon
                type="monitor-03"
                size={40}
                fill="none"
                stroke={theme().colors.darkerBlue}
                strokeWidth={1.5}
              />
              <Text type="b4">
                Per navigare tutti i contenuti riguardanti le statistiche
                effettua l'accesso via web tramite computer!
              </Text>
            </InfoBoxMobile>
          )}
        </TitleWrapper>
        {/* First Row */}
        <Card>
          <div className="d-flex sb">
            <Text type="h2.5">Utenti</Text>
            {!reducedStats && (
              <CTA
                type="tertiary"
                btnText="Tutti gli utenti"
                icon="arrow-narrow-right"
                bottomRight
                onClick={() => modalOpen(ModalSupervisorUsersId)}
              />
            )}
          </div>
          <div className="filters-wrapper">
            <Text type="b5">Visualizza per:</Text>
            <CustomSelect
              size={mediaIsPhone ? 'full' : 'compact'}
              options={(myUsers?.filters?.filter ?? []).map((opt) =>
                formatFilterOpt(opt)
              )}
              onChange={({ value }) => {
                setMyUsersFilters({ ...myUsersFilters, filter: value });
                setFilterIsProvince(value === 'province');
              }}
              disabled={reducedStats}
              selected={(myUsers?.filters?.filter ?? [])
                .map((opt) => formatFilterOpt(opt))
                ?.filter((item) => item.value === myUsersFilters?.filter)}
            />
            {filterIsProvince && (
              <CustomSelect
                options={(myUsers?.filters?.region ?? []).map((opt) =>
                  formatFilterOpt(opt)
                )}
                placeholder="Regione"
                size={mediaIsPhone ? 'full' : 'compact'}
                onChange={({ value }) =>
                  setMyUsersFilters({
                    ...myUsersFilters,
                    filter: 'province',
                    region: value,
                  })
                }
              />
            )}
            <Text type="b5">Seleziona il periodo temporale:</Text>
            <TimeIntervalFilter
              size={mediaIsPhone ? 'full' : 's'}
              callback={(start_date, end_date) => {
                setMyUsersFilters({
                  ...myUsersFilters,
                  start_date,
                  end_date,
                });
              }}
              singleMonth
              maxMonthsDiff={1}
              defaultStartDate={getCurrentMonthDate()}
              defaultEndDate={getCurrentMonthDate()}
            />
          </div>
          {myUsersFilters?.filter === 'ffoo' ? (
            <>
              <ChartsWrapper>
                <div className="d-flex sb chart-container">
                  <div>
                    <Text type="h3.5" mb={16}>
                      Assegnazioni
                    </Text>
                    <Text type="b5">
                      Panoramica degli utenti che visualizzano almeno un
                      percorso formativo
                    </Text>
                  </div>
                  <div className="chart-wrapper">
                    <CircularStats
                      label="Utenti totali"
                      size={mediaIsPhone ? 190 : 130}
                      data={formatUsers(myUsers?.assignments)}
                      chartOnly
                      mt={0}
                    />
                  </div>
                </div>
                <div className="d-flex sb chart-container">
                  <div>
                    <Text type="h3.5" mb={16}>
                      Fruizioni
                    </Text>
                    <Text type="b5">
                      Panoramica degli utenti che fruiscono di almeno un
                      percorso formativo
                    </Text>
                  </div>
                  <div className="chart-wrapper">
                    <CircularStats
                      label="Utenti totali"
                      size={mediaIsPhone ? 190 : 130}
                      data={formatUsers(myUsers?.fruitions)}
                      dataLabels={getDataLabels(myUsers)}
                      chartOnly
                      mt={0}
                    />
                  </div>
                </div>
                <div className="d-flex sb chart-container last">
                  <div>
                    <Text type="h3.5" mb={16}>
                      Completamenti
                    </Text>
                    <Text type="b5">
                      Panoramica degli utenti che hanno completato almeno un
                      percorso formativo
                    </Text>
                  </div>
                  <div className="chart-wrapper">
                    <CircularStats
                      label="Utenti totali"
                      size={mediaIsPhone ? 190 : 130}
                      data={formatUsers(myUsers?.completions)}
                      dataLabels={getDataLabels(myUsers)}
                      chartOnly
                      mt={0}
                    />
                  </div>
                </div>
              </ChartsWrapper>
              <RefreshAndLegend>
                {!mediaIsPhone && (
                  <RefreshBtn
                    cacheTag={myUsers?.cache_tag}
                    callback={() => getMyUsers(myUsersFilters)}
                  />
                )}
                <ChartLegend>
                  {(myUsers?.assignments?.items || []).map((item, i) => (
                    <LegendItem key={`legend-item-${i}`}>
                      <ColorBox
                        color={
                          generateColorPalette(
                            myUsers?.assignments?.items?.length
                          )[i]
                        }
                      />
                      <Text type="b5" className="ellipsis">
                        {item?.label}
                      </Text>
                    </LegendItem>
                  ))}
                </ChartLegend>
              </RefreshAndLegend>
            </>
          ) : (
            <>
              <div className="barchart-wrapper">
                <BarChart
                  config={barChartConfigMultiSets(regionProvinceStatistics)}
                  customOptions={REGION_PROVINCE_CHART_OPTS}
                />
              </div>
              <DataAndLegend>
                <FullDataBox>
                  <DataBit>
                    <Text type="b5">Assegnazioni:</Text>
                    <Text type="h3.5" color="#003366">
                      {formatNumberToK(myUsers?.assignments?.total_users) ?? 0}
                    </Text>
                  </DataBit>
                  <DataBit>
                    <Text type="b5">Fruizioni:</Text>
                    <Text type="h3.5" color="#003366">
                      {formatNumberToK(myUsers?.fruitions?.total_users) ?? 0}
                    </Text>
                  </DataBit>
                  <DataBit>
                    <Text type="b5">Completamenti:</Text>
                    <Text type="h3.5" color="#003366">
                      {formatNumberToK(myUsers?.completions?.total_users) ?? 0}
                    </Text>
                  </DataBit>
                </FullDataBox>
                <ChartLegend>
                  {regionsProvinceLabels.map((item, i) => (
                    <LegendItem key={`legend-item-${i}`}>
                      <ColorBox
                        color={
                          generateColorPalette(regionsProvinceLabels.length)[i]
                        }
                      />
                      <Text type="b5" className="ellipsis">
                        {item}
                      </Text>
                    </LegendItem>
                  ))}
                </ChartLegend>
              </DataAndLegend>
              {!mediaIsPhone && (
                <div style={{ marginTop: 16 }}>
                  <RefreshBtn
                    cacheTag={myUsers?.cache_tag}
                    callback={() => getMyUsers(myUsersFilters)}
                  />
                </div>
              )}
            </>
          )}
          {mediaIsPhone && (
            <div style={{ order: 99 }}>
              <RefreshBtn
                cacheTag={myUsers?.cache_tag}
                callback={() => getMyUsers(myUsersFilters)}
              />
            </div>
          )}
        </Card>
        <CardsGrid id="generalStats">
          {/* Second Row */}
          <Card className="large">
            <div className="d-flex sb">
              <Text type="h2.5" mb={mediaIsPhone || mediaIsTablet ? 16 : 0}>
                Accessi
              </Text>
              {!reducedStats && (
                <CTA
                  type="tertiary"
                  btnText="Tutti gli utenti"
                  icon="arrow-narrow-right"
                  bottomRight
                  onClick={() => modalOpen(ModalSupervisorUsersId)}
                />
              )}
            </div>
            <LargeChartGrid>
              <TextAndFilter>
                <Text type="b5" mt={mediaIsPhone || mediaIsTablet ? 0 : 8}>
                  Di seguito la panoramica degli accessi effettuati sulla
                  piattaforma
                </Text>
                <TimeIntervalFilter
                  size={mediaIsPhone ? 'full' : 's'}
                  callback={(start_date, end_date) => {
                    if (!start_date || !end_date) return;
                    setAccessStatisticsFilters({
                      ...accessStatisticsFilters,
                      start_date,
                      end_date,
                    });
                  }}
                  singleMonth
                  maxMonthsDiff={1}
                  defaultStartDate={getCurrentMonthDate()}
                  defaultEndDate={getCurrentMonthDate()}
                />
              </TextAndFilter>
              <EmptyElement />
              <BarChart
                config={barChartConfigWithTrend(
                  formatAccessStats(
                    accesses?.list,
                    accessStatisticsFilters?.start_date
                  )
                )}
                customOptions={ACCESS_STATS_CHART_OPTS}
              />
              <div className="info-box">
                <Text type="h1.5" mb={12}>
                  {accesses?.currently_active_users}
                </Text>
                <Text type="b4" mb={12}>
                  Utenti attivi al momento
                </Text>
              </div>
              <RefreshBtn
                cacheTag={accesses?.cache_tag}
                callback={() =>
                  getAccessStatisticsList(accessStatisticsFilters)
                }
              />
            </LargeChartGrid>
          </Card>
          <Card className="span-2">
            <CardInner>
              <div>
                <div className="d-flex sb">
                  <Text type="h2.5">Tutor accreditati</Text>
                  {!reducedStats && (
                    <CTA
                      type="tertiary"
                      btnText="Tutti i tutor"
                      icon="arrow-narrow-right"
                      bottomRight
                      onClick={() => modalOpen(ModalSupervisorTutorsId)}
                    />
                  )}
                </div>
                <Text type="b5" mt={mediaIsPhone || mediaIsTablet ? 16 : 8}>
                  Di seguito la panoramica dei tutor accreditati all’interno
                  della piattaforma.
                </Text>
              </div>
              <TutorChartWrapper>
                <CircularStats
                  label="Tutor totali"
                  size={mediaIsPhone ? 190 : 145}
                  data={arrayToKeyValue(tutors?.list, 'label', 'count')}
                  mt={0}
                />
              </TutorChartWrapper>
              <RefreshBtn
                cacheTag={tutors?.cache_tag}
                callback={() => getTutorStatisticsList()}
              />
            </CardInner>
          </Card>
          {/* Third Row */}
          <Card className="span-2">
            <CardInner>
              <div>
                <Column rowGap={mediaIsPhone || mediaIsTablet ? 16 : 8}>
                  <div className="d-flex sb">
                    <Text type="h2.5">
                      Aree tematiche:&nbsp;
                      <span style={{ color: theme().colors.badgeActive }}>
                        {categories?.count_category}
                      </span>
                    </Text>
                    {!reducedStats && (
                      <CTA
                        type="tertiary"
                        btnText="Tutte le aree tematiche"
                        icon="arrow-narrow-right"
                        onClick={() => modalOpen(ModalSupervisorCategoriesId)}
                      />
                    )}
                  </div>
                  <TimeIntervalFilter
                    size={mediaIsPhone ? 'full' : 's'}
                    callback={(start_date, end_date) => {
                      setCategoryStatisticsFilters({
                        ...categoryStatisticsFilters,
                        start_date,
                        end_date,
                      });
                    }}
                    singleMonth
                    maxMonthsDiff={1}
                    defaultStartDate={getCurrentMonthDate()}
                    defaultEndDate={getCurrentMonthDate()}
                  />
                  <Text type="b5">
                    Di seguito le aree tematiche più popolari:
                  </Text>
                  <BarChart
                    config={barChartConfig(
                      arrayToKeyValue(
                        categories?.list,
                        'name',
                        'category_count'
                      )
                    )}
                    horizontal
                  />
                </Column>
              </div>
              <RefreshBtn
                cacheTag={categories?.cache_tag}
                callback={() =>
                  getCategoryStatisticsList(categoryStatisticsFilters)
                }
              />
            </CardInner>
          </Card>
          <Card className="span-2">
            <CardInner>
              <div>
                <Column rowGap={mediaIsPhone || mediaIsTablet ? 16 : 8}>
                  <div className="d-flex sb">
                    <Text type="h2.5">
                      Percorsi formativi:&nbsp;
                      <span style={{ color: theme().colors.badgeActive }}>
                        {courses?.count_courses}
                      </span>
                    </Text>
                    {!reducedStats && (
                      <CTA
                        type="tertiary"
                        btnText="Tutti i percorsi"
                        icon="arrow-narrow-right"
                        onClick={() => modalOpen(ModalSupervisorCoursesId)}
                      />
                    )}
                  </div>
                  <CourseFiltersWrapper>
                    <CustomSelect
                      size={mediaIsPhone ? 'full' : 'compact'}
                      options={COURSE_STATS_OPTS}
                      onChange={({ value }) => {
                        setCourseStatisticsFilters({
                          ...courseStatisticsFilters,
                          filter: value,
                        });
                      }}
                      selected={
                        COURSE_STATS_OPTS.find(
                          ({ value }) =>
                            value === courseStatisticsFilters?.filter
                        ) || COURSE_STATS_OPTS[0]
                      }
                    />
                    <TimeIntervalFilter
                      size={mediaIsPhone ? 'full' : 's'}
                      callback={(start_date, end_date) => {
                        setCourseStatisticsFilters({
                          ...courseStatisticsFilters,
                          start_date,
                          end_date,
                        });
                      }}
                      singleMonth
                      maxMonthsDiff={1}
                      defaultStartDate={getCurrentMonthDate()}
                      defaultEndDate={getCurrentMonthDate()}
                    />
                  </CourseFiltersWrapper>
                  <Text type="b5">
                    Sono stati creati&nbsp;
                    {courses?.list[0]?.count ?? 0}&nbsp;
                    {courseStatisticsFilters?.filter === 'nazionali_locali'
                      ? 'percorsi formativi locali'
                      : 'corsi'}{' '}
                    e&nbsp;
                    {courses?.list[1]?.count ?? 0}&nbsp;
                    {courseStatisticsFilters?.filter === 'nazionali_locali'
                      ? 'nazionali'
                      : 'eventi'}
                    .
                  </Text>
                  <BarChart
                    config={barChartConfig(
                      arrayToKeyValue(courses?.list, 'label', 'count')
                    )}
                    customOptions={COURSE_STATS_CHART_OPTS}
                  />
                </Column>
              </div>
              <RefreshBtn
                cacheTag={courses?.cache_tag}
                callback={() =>
                  getCourseStatisticsList(courseStatisticsFilters)
                }
              />
            </CardInner>
          </Card>
          <Card className="span-2">
            <CardInner>
              <div>
                <Column rowGap={mediaIsPhone || mediaIsTablet ? 16 : 8}>
                  <div className="d-flex sb">
                    <Text type="h2.5">
                      Attività:&nbsp;
                      <span style={{ color: theme().colors.badgeActive }}>
                        {activities?.total_activity}
                      </span>
                    </Text>
                    {!reducedStats && (
                      <CTA
                        type="tertiary"
                        btnText="Tutte le attività"
                        icon="arrow-narrow-right"
                        onClick={() => modalOpen(ModalSupervisorActivitiesId)}
                      />
                    )}
                  </div>
                  <TimeIntervalFilter
                    size={mediaIsPhone ? 'full' : 's'}
                    callback={(start_date, end_date) => {
                      setActivityStatisticsFilters({
                        ...activityStatisticsFilters,
                        start_date,
                        end_date,
                      });
                    }}
                    singleMonth
                    maxMonthsDiff={1}
                    defaultStartDate={getCurrentMonthDate()}
                    defaultEndDate={getCurrentMonthDate()}
                  />
                  <Text type="b5">
                    Sono state create{' '}
                    {activityStatisticsFilters?.start_date
                      ? activities?.total_activity_by_date
                      : activities?.total_activity}{' '}
                    attività.
                  </Text>
                  <BarChart
                    config={barChartConfig(
                      arrayToKeyValue(
                        activities?.list,
                        'category_name',
                        'category_count'
                      )
                    )}
                    customOptions={ACTIVITY_STATS_CHART_OPTS}
                  />
                </Column>
              </div>
              <RefreshBtn
                cacheTag={activities?.cache_tag}
                callback={() =>
                  getActivityStatisticsList(activityStatisticsFilters)
                }
              />
            </CardInner>
          </Card>
        </CardsGrid>
      </Container>
      <ModalsWrapper>
        {isOpen && (
          <>
            {modalId === ModalSupervisorUsersId && <ModalSupervisorUsers />}
            {modalId === ModalSupervisorCoursesId && <ModalSupervisorCourses />}
            {modalId === ModalSupervisorTutorsId && <ModalSupervisorTutors />}
            {modalId === ModalSupervisorCategoriesId && (
              <ModalSupervisorCategories />
            )}
            {modalId === ModalSupervisorActivitiesId && (
              <ModalSupervisorActivities />
            )}
          </>
        )}
      </ModalsWrapper>
    </>
  );
};

Statistics.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  // HOC: state
  myUsers: PropTypes.object,
  accesses: PropTypes.object,
  activities: PropTypes.object,
  categories: PropTypes.object,
  courses: PropTypes.object,
  tutors: PropTypes.object,
  isOpen: PropTypes.bool,
  modalId: PropTypes.string,
  // HOC: dispatch
  modalOpen: PropTypes.func.isRequired,
  getMyUsers: PropTypes.func,
  getAccessStatisticsList: PropTypes.func,
  getActivityStatisticsList: PropTypes.func,
  getCategoryStatisticsList: PropTypes.func,
  getCourseStatisticsList: PropTypes.func,
  getTutorStatisticsList: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const { myUsers } = state.statistics.charts;
      const { accesses, activities, categories, courses, tutors } =
        state.supervisorStats.charts;
      const { isOpen, id: modalId } = state.app.modal;
      return {
        myUsers,
        accesses,
        activities,
        categories,
        courses,
        tutors,
        isOpen,
        modalId,
      };
    },
    (dispatch) => ({
      modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
      getMyUsers: (filters) =>
        dispatch({
          type: MY_USERS_GET._REQUEST,
          filters,
          status_array: ['assignments', 'fruitions', 'completions'],
        }),
      getAccessStatisticsList: (filters) =>
        dispatch({ type: ACCESS_STATISTICS_LIST_GET._REQUEST, filters }),
      getActivityStatisticsList: (filters) =>
        dispatch({ type: ACTIVITY_STATISTICS_LIST_GET._REQUEST, filters }),
      getCategoryStatisticsList: (filters) =>
        dispatch({ type: CATEGORY_STATISTICS_LIST_GET._REQUEST, filters }),
      getCourseStatisticsList: (filters) =>
        dispatch({ type: COURSE_STATISTICS_LIST_GET._REQUEST, filters }),
      getTutorStatisticsList: () =>
        dispatch({ type: TUTOR_STATISTICS_LIST_GET._REQUEST }),
    })
  ),
  withMediaQueries
)(Statistics);
